import axios from 'axios'
import {EVENT} from '../../url_constants';

export default {
  createSchedule(data = {}) {
    return axios({
      method: 'PUT',
      url: EVENT,
      data
    });
  },
  updateSchedule(data = {}) {
    return axios({
      method: 'POST',
      url: `${EVENT}/update`,
      data
    });
  },
  cancelSchedule(data = {}) {
    return axios({
      method: 'POST',
      url: `${EVENT}/cancel`,
      data
    });
  },
  getSchedule(id) {
    return axios({
      method: 'GET',
      url: `${EVENT}?eventId=${id}`
    });
  },
  confirmSchedule(data) {
    return axios({
      method: 'POST',
      url: `${EVENT}/book`,
      data
    });
  },
}